export default __webpack_public_path__ + "static/mistake-1-6d819225cb1244643698321e416bf73a.png";